import React from 'react';
import FormBuilder from './FormBuilder';

const CreateForm = () => {
  return <FormBuilder mode="create" />;
};

export default CreateForm;